import { render, staticRenderFns } from "./sizes-guide.vue?vue&type=template&id=0386acb6&scoped=true"
import script from "./sizes-guide.vue?vue&type=script&lang=js"
export * from "./sizes-guide.vue?vue&type=script&lang=js"
import style0 from "./sizes-guide.vue?vue&type=style&index=0&id=0386acb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386acb6",
  null
  
)

export default component.exports